import { useState, useRef, useEffect } from "react";
import { FaShoppingCart, FaTrash } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import "../asset/css/CartWidget.css";

export default function CartWidget({ open }) {
  const { cartItems, removeFromCart } = useCart();
  const [isOpen, setIsOpen] = useState(open || false);
  const [visible, setVisible] = useState(cartItems.length > 0);
  const dropdownRef = useRef(null);

  
  useEffect(() => {
    if (cartItems.length > 0) {
      setVisible(true);
    } else {
      
      const timer = setTimeout(() => setVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [cartItems]);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const toggleCart = () => setIsOpen(!isOpen);

  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const totalPrice = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  if (!visible) return null; 

  return (
    <div className={`cart-widget ${visible ? "fade-in" : "fade-out"}`}>
      <button
        onClick={toggleCart}
        className="cart-button"
      >
        <FaShoppingCart />
        {cartItems.length > 0 && (
          <span className="cart-badge">{cartItems.length}</span>
        )}
      </button>

      {isOpen && (
        <div
          ref={dropdownRef}
          className={`cart-dropdown ${isOpen ? "open" : ""}`}
        >
          <h3>Panier</h3>
          {cartItems.length === 0 ? (
            <p>Votre panier est vide.</p>
          ) : (
            <>
              <ul className="cart-items">
                {cartItems.map((item) => (
                  <li key={item?.id} className="cart-item">
                    <div>
                      <strong>{item?.productTitle ?? "Produit inconnu"}</strong>
                      <p>
                        {item?.quantity ?? 0} x {(item?.price ?? 0).toFixed(2)} €
                      </p>
                    </div>
                    <button
                      onClick={() => removeFromCart(item?.id)}
                      className="cart-remove"
                    >
                      <FaTrash />
                    </button>
                  </li>
                ))}
              </ul>
              <hr />
              <p className="cart-total">Total: {totalPrice.toFixed(2)} €</p>
              <Link
                to="/cart"
                onClick={() => setIsOpen(false)}
                className="cart-link"
              >
                Voir le panier
              </Link>
            </>
          )}
        </div>
      )}
    </div>
  );
}
